import { memo } from "react";
import type { GridRenderCellParams } from "@mui/x-data-grid";
import { TableGridMode } from "consts/table";
import { Filters, MenuItem } from "consts/openBanking";
import type { IbanXsBank } from "features/openBanking/types";
import {
    selectOpenBankingResourceSlice,
    selectIsOpenBankingResourceLoading,
    selectIsOpenBankingResourceUninitialized
} from "features/openBanking/selectors";
import IbanXSToolbar from "./IbanXSToolbar";
import IbanXSDetail from "./IbanXSDetail";
import useIbanXS from "./useIbanXS";
import { OpenBankingResource, LogoUrl } from "../shared";

const IbanXS = () => (
    <OpenBankingResource
        BreadcrumbsProps={{
            heading: 'Iban XS'
        }}
        ResourceProps={{
            name: 'Iban XS',
            useResource: useIbanXS,
            mode: TableGridMode.OpenBankingIbanXS,
            columns: [
                {
                    field: Filters.logoUrl,
                    headerName: 'Logo',
                    minWidth: 160,
                    renderCell: (params: GridRenderCellParams<IbanXsBank['logoUrl']>) => (
                        <LogoUrl
                            {...params}
                        />
                    ),
                    headerAlign: 'center',
                    align: 'center'
                }
            ],
            selectIsTableUninitialized: selectIsOpenBankingResourceUninitialized(MenuItem.IbanXS),
            selectIsTableLoading: selectIsOpenBankingResourceLoading(MenuItem.IbanXS),
            selectTableDataSlice: selectOpenBankingResourceSlice(MenuItem.IbanXS),
            Toolbar: IbanXSToolbar,
            Detail: IbanXSDetail
        }}
    />
);

export default memo(IbanXS);
